// extracted by mini-css-extract-plugin
export default {"group":"BadgeGroups_group__oxLzl","badge":"BadgeGroups_badge__1jxzl","infoBadge":"BadgeGroups_infoBadge__AOTDd","invisibleButton":"BadgeGroups_invisibleButton__xekFq"};